import { Injectable } from '@angular/core';
import { BookWidgetFieldUpdateTypes } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { validateBookWidgetFields } from '../../../adapters/book-widget-fields-validation/book-widget-fields-validation.adapter';
import * as fromBookWidgetActions from '../../actions/book-widget.actions';
import { getBookWidgetAem } from '../../selectors/aem.selectors';
import {
  getBookWidgetFields,
  getStartFieldsValidationValue
} from '../../selectors/book-widget.selectors';

@Injectable({
  providedIn: 'root'
})
export class BookWidgetFieldsValidationEffects {
  setFieldsAfterValidation1$ = createEffect(
    (): Observable<Action> =>
      this.Actions$.pipe(
        ofType(fromBookWidgetActions.FindFlightInitiated),
        concatLatestFrom(() => [
          this.store.select(getBookWidgetFields),
          this.store.select(getStartFieldsValidationValue),
          this.store.select(getBookWidgetAem)
        ]),
        switchMap(
          ([, bookWidgetFields, startFieldsValidation, bookWidgetAem]) => {
            const { updatedBookWidgetFields, fieldsErrorCount } =
              validateBookWidgetFields(
                bookWidgetFields,
                startFieldsValidation,
                bookWidgetAem
              );

            return of(
              fromBookWidgetActions.SetFieldsAfterValidation({
                bookWidgetFields: updatedBookWidgetFields,
                fieldsErrorCount
              }),
              fromBookWidgetActions.FindFlightProceed()
            );
          }
        )
      )
  );

  setFieldsAfterValidation2$ = createEffect(
    (): Observable<Action> =>
      this.Actions$.pipe(
        ofType(
          fromBookWidgetActions.ApplyBookWidgetFieldChangeRules,
          fromBookWidgetActions.BookWidgetFieldChange
        ),
        filter(({ bookWidgetFieldUpdateEvent: { type } }) =>
          [
            BookWidgetFieldUpdateTypes.shopMiles,
            BookWidgetFieldUpdateTypes.originAirport,
            BookWidgetFieldUpdateTypes.destinationAirport,
            BookWidgetFieldUpdateTypes.connectionAirport,
            BookWidgetFieldUpdateTypes.datesChange,
            BookWidgetFieldUpdateTypes.meetingEventCode,
            BookWidgetFieldUpdateTypes.tripType
          ].includes(type)
        ),
        concatLatestFrom(() => [
          this.store.select(getBookWidgetFields),
          this.store.select(getStartFieldsValidationValue),
          this.store.select(getBookWidgetAem)
        ]),
        switchMap(
          ([, bookWidgetFields, startFieldsValidation, bookWidgetAem]) => {
            const { updatedBookWidgetFields, fieldsErrorCount } =
              validateBookWidgetFields(
                bookWidgetFields,
                startFieldsValidation,
                bookWidgetAem
              );

            return of(
              fromBookWidgetActions.SetFieldsAfterValidation({
                bookWidgetFields: updatedBookWidgetFields,
                fieldsErrorCount
              })
            );
          }
        )
      )
  );

  setFieldsAfterValidation3$ = createEffect(
    (): Observable<Action> =>
      this.Actions$.pipe(
        ofType(
          fromBookWidgetActions.SwapAirports,
          fromBookWidgetActions.AddFlightsForMc,
          fromBookWidgetActions.RemoveFlightForMc,
          fromBookWidgetActions.UpdateFieldsFromSavedSearch,
          fromBookWidgetActions.UpdateFieldsFromRecentSearch
        ),
        concatLatestFrom(() => [
          this.store.select(getBookWidgetFields),
          this.store.select(getStartFieldsValidationValue),
          this.store.select(getBookWidgetAem)
        ]),
        switchMap(
          ([, bookWidgetFields, startFieldsValidation, bookWidgetAem]) => {
            const { updatedBookWidgetFields, fieldsErrorCount } =
              validateBookWidgetFields(
                bookWidgetFields,
                startFieldsValidation,
                bookWidgetAem
              );

            return of(
              fromBookWidgetActions.SetFieldsAfterValidation({
                bookWidgetFields: updatedBookWidgetFields,
                fieldsErrorCount
              })
            );
          }
        )
      )
  );

  constructor(private Actions$: Actions, private store: Store) {}
}
